/**
 * `/privacidad` — qué datos guarda Clica (§16.4).
 *
 * En castellano llano y sin párrafos legales: quien lo va a leer tiene catorce años. Lo que dice
 * está sacado de §16.1 y §16.3, así que si allí cambia algo, aquí también tiene que cambiar.
 */

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { SelectorIdioma } from '../components/selector-idioma.js';

export function PantallaPrivacidad(): React.JSX.Element {
  const { t } = useTranslation();

  const SECCIONES = [
    { titulo: 'privacy.storedTitle', texto: 'privacy.stored' },
    { titulo: 'privacy.notStoredTitle', texto: 'privacy.notStored' },
    { titulo: 'privacy.retentionTitle', texto: 'privacy.retention' },
    { titulo: 'privacy.rightsTitle', texto: 'privacy.rights' },
  ] as const;

  return (
    <main id="contenido" className="mx-auto max-w-2xl p-6">
      <div className="flex justify-end">
        <SelectorIdioma />
      </div>

      <h1 className="font-display mt-4 text-3xl font-bold">{t('privacy.title')}</h1>
      <p className="mt-4">{t('privacy.intro')}</p>

      {SECCIONES.map((seccion) => (
        <section key={seccion.titulo} className="mt-8">
          <h2 className="text-xl font-semibold">{t(seccion.titulo)}</h2>
          <p className="mt-2">{t(seccion.texto)}</p>
        </section>
      ))}

      <p className="mt-10">
        <Link to="/" className="underline underline-offset-4">
          {t('app.name')}
        </Link>
      </p>
    </main>
  );
}
